export default {
    config: {
        defaultWidth: {
            default: 80,
            sheet: 160
        },
    },
    default: {
        label: 'Date'
    },
    unique: [],
    sort: 'rating.date',
    lang: {
        name: 'Date Rated',
        category: ['User', 'Ratings'],
        description: 'When the game was rated.',
        views: ['list', 'sheet', 'grid'],
    },
    filters: ['date.rated']
}